const createPt125InitState = () => ({
  productInfo: [],
  navList: [],
  colSizList: [],
  detailList: [],
  favoritesList: [],
  totalReviewRank: [],
  uketoriServiceKbn: {},
  descriptionInfo: {},
  pt400DescriptionInfo: {},
  sh030DescriptionInfo: {},
  sh050DescriptionInfo: {},
  sh060DescriptionInfo: {},
  colorTitle: '',
  sizeTitle: '',
  syukkaYoteiDate: '',
  siteFlg: null,
  priceFlg: null,
  facebookUrl: null,
  facebookAttr: null,
  loginKbn: false,
  shahanFlg: null,
  colorSizeFlg: false,
  reviewList: null,
  itemStdFlg: 0,
});

const createPt125ReqModelState = () => ({
  sItemNo: null,
  colSzSItemNo: null,
  yoyakuItemFlg: null,
  categoryCd: null,
  buyCount: null,
  wariPrice: null,
  cartAddKbn: null,
  pointFlg: 0,
  agreeFlag: 0,
  kokyakuCd: null,
  mail: null,
  mailOld: null,
  mail_confirm: null,
  password: null,
  passwordSub: null,
  prePassword: null,
  nm1: null,
  nm2: null,
  nm3: null,
  kana1: null,
  kana2: null,
  kana3: null,
  birthDayYYYY: null,
  birthDayMM: null,
  birthDayDD: null,
  sexKbn: '9',
  zip: null,
  zip1: null,
  zip2: null,
  kenCd: null,
  kenNm: null,
  addr1: null,
  addr2: null,
  addr3: null,
  tel1: null,
  fax: null,
  newsMailRcvFlg: '0',
  dmFlg: '0',
  kokyakuRankKbn: null,
  kokyakuRankKbnNm: null,
  pointNum: null,
  exclCnt: null,
  nickname: null,
  ageOpenFlg: '0',
  sexOpenFlg: '0',
  kaiinCheck: null,
  radioGroup: '1',
  tdkNo: '0',
  tdkNm1: '',
  tdkNm2: '',
  tdkKana1: '',
  tdkKana2: '',
  tdkZip: '',
  tdkKenCd: '',
  tdkKenNm: '',
  tdkAddr1: '',
  tdkAddr2: '',
  tdkAddr3: '',
  tdkTel: '',
  tdkMail1: '',
  kessaiCd: null,
  sagyoKanriKomokuCd: null,
  sagyoKanriKomokuCd2: null,
  noshiNaire1: null,
  noshiNaire2: null,
  securityCode: '',
  cardSecurity: '',
  sbp3DVerFlg: 0,
  tds2InfoToken: '',
  tds2InfoTokenKey: '',
  sbp3DVerBackUr: '',
  tdsAuthenticationId: '',
  resSbpCustId: '',
  apiRequestId: '',
  resApiErrCode: '',
  resApiResult: '',
});

const state = () => ({
  pt125Init: createPt125InitState(),
  pt125ReqModel: createPt125ReqModelState(),
});

const mutations = {
  RESET_PT125_STATE(currentState) {
    currentState.pt125Init = createPt125InitState();
    currentState.pt125ReqModel = createPt125ReqModelState();
  },
  SET_PT125_INIT(currentState, payload = {}) {
    currentState.pt125Init = payload || {};
  },
  MERGE_PT125_INIT(currentState, payload = {}) {
    currentState.pt125Init = Object.assign({}, currentState.pt125Init, payload);
  },
  SET_PT125_REQ_MODEL(currentState, payload = {}) {
    currentState.pt125ReqModel = payload || {};
  },
  MERGE_PT125_REQ_MODEL(currentState, payload = {}) {
    currentState.pt125ReqModel = Object.assign({}, currentState.pt125ReqModel, payload);
  },
};

const getters = {
  pt125Init: currentState => currentState.pt125Init,
  pt125ReqModel: currentState => currentState.pt125ReqModel,
};

export {
  createPt125InitState,
  createPt125ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
